export default class SessionTabs {
    static async share(key, timeout) {
        if (!sessionStorage.getItem(`get-${key}`)) {
            localStorage.setItem(`get-${key}`, Date.now());
        }

        let resolve;
        const promise = new Promise((r) => { resolve = r; });

        window.addEventListener('storage', (event) => {
            if (event.key === `get-${key}`) {
                localStorage.setItem(`set-${key}`, sessionStorage.getItem(key));
                localStorage.removeItem(`set-${key}`);
            } else if (event.key === `set-${key}` && !sessionStorage.getItem(key)) {
                sessionStorage.setItem(key, event.newValue);
                resolve();
            }
        });

        return Promise.race([promise, this.wait(timeout ?? 200)]);
    }

    static wait(ms) {
        return new Promise((resolve) => {
            setTimeout(() => resolve(), ms);
        });
    }
}
